import { combineReducers, createStore, ReducersMapObject } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import reducerRegistry from './reducerRegistry';

export function combine(initialState: any = {}, reducers: ReducersMapObject) {
    const reducerNames = Object.keys(reducers);

    for (const key in initialState) {
        reducerNames.indexOf(key) === -1 && (reducers[key] = (state = null) => state);
    }

    return Object.keys(reducers).length > 0
        ? combineReducers(reducers)
        : () => {};
}

export default function configureStore(initialState?: any, registry = reducerRegistry) {
    const initialReducer = combine(initialState, registry.getReducers());
    const store = createStore(initialReducer, initialState, composeWithDevTools());

    registry.setChangeListener(reducers => {
        store.replaceReducer(combine(initialState, reducers));
    });

    return store;
}
